import { render } from "./FormMessage.vue?vue&type=template&id=3ce8ffe4&scoped=true"
import script from "./FormMessage.vue?vue&type=script&lang=js"
export * from "./FormMessage.vue?vue&type=script&lang=js"

import "./FormMessage.vue?vue&type=style&index=0&id=3ce8ffe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce8ffe4"]])

export default __exports__